import styled from '@emotion/styled';
import { ProfileImage } from 'app-components/accounts/profiles/ProfileImage';
import React from 'react';
import { useAuthState } from 'contexts/AuthProvider';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { Link } from 'ui-components/common/Link';
import { Color } from '@diritto/common/style/color';
import { MyContentIcon } from 'icons/MyContentIcon';

export const DirittoStudioLeftMenu = () => {
  const { profile } = useAuthState();

  if (!profile) {
    return null;
  }

  return (
    <StyledContainer>
      <StyledProfileWrapper>
        <ProfileImage file={profile.profileImage} defaultImageKey={profile.nickname} size={96} />
        <StyledProfileName>{profile.nickname}</StyledProfileName>
      </StyledProfileWrapper>
      <StyledMenuWrapper>
        <StyleLink href="/studio" replace>
          <StyledMenu>
            <MyContentIcon className="size-[26px]" color={Color.Primary500} />내 작품
          </StyledMenu>
        </StyleLink>
      </StyledMenuWrapper>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  width: 192px;
  padding: 16px 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const StyledProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledProfileName = styled.div`
  ${Typography.XXSmall};
  font-weight: ${FontWeight.Bold};
  text-align: center;
  padding: 8px;
  word-break: break-all;
`;

const StyledMenuWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 0 16px;
`;

const StyledMenu = styled.div`
  height: 48px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 16px;
  border-radius: 4px;

  background-color: ${Color.Primary100};
  color: ${Color.Primary500};
  ${Typography.XXSmall};
  font-weight: ${FontWeight.Bold};
`;

const StyleLink = styled(Link)`
  width: 100%;
`;
